import React from "react";
import Header from "../../layouts/admin/AdminHeader";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import RefreshIcon from "@mui/icons-material/Refresh";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import path from "../../path";
import useEncryption from "../../services/useEncryption";
import useHeaders from "../../helpers/useHeaders";
import { selectLoc } from "../../redux/slice/locSlice";
import { createAuditLogs } from "../../api/providerApi/providerApi";
import { AdminLogsDetails } from "./components/AdminLogsDetails";
import { AdminFormSortLogs } from "./components/AdminFormSortLogs";

export const AdminLogs = () => {
  const [value, setValue] = React.useState("1");
  const [search, setSearch] = React.useState("");
  const [locationSearch, setLocationSearch] = React.useState("");
  const [locations, setLocations] = React.useState([]);
  const [selectedLocation, setSelectedLocation] = React.useState(null);
  const { selectedLogs } = useSelector(selectLoc);
  const headers = useHeaders();
  const { encryptData } = useEncryption();

  React.useEffect(() => {
    const controller = new AbortController();

    const fetchLocations = async () => {
      try {
        const response = await fetch(
          `${path}/v1/logs/all-provider?search=${encodeURIComponent(
            locationSearch || ""
          )}`,
          {
            signal: controller.signal,
            headers,
          }
        );
        const data = await response.json();
        setLocations(Array.isArray(data.data) ? data.data : []);
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Error fetching locations:", error);
        }
      }
    };

    fetchLocations();

    return () => controller.abort();
  }, [locationSearch]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const downloadCSVFile = async () => {
    try {
      if (selectedLogs.length == 0) {
        toast.error("Please select some records to export in CSV File.");
        return;
      }
      window.location.href = `${path}/v1/logs/generate-logs?records=${encodeURIComponent(
        encryptData(selectedLogs)
      )}`;
      //audit log
      let obj = {
        event: "SuperAdmin has download the CSV file for Logs.",
      };

      await createAuditLogs({ data: encryptData(obj) }, headers);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  return (
    <div>
      <Header pageTitle="Logs" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle">Log Details</div>
          {/* <button className="btn blackoutlineBtn">Refresh</button> */}
        </div>
        <div className="cardcontents">
          <TabContext className="tabsDesigns" value={value}>
            <Tabs className="butoontabdesigns" onChange={handleChange}>
              <Tab
                className={value === "1" ? "actived" : ""}
                label="Audit Logs"
                value="1"
              />
              <Tab
                className={value === "2" ? "actived" : ""}
                label="Login Logs"
                value="2"
              />
              <Tab
                className={value === "3" ? "actived" : ""}
                label="FormSort Logs"
                value="3"
              />
            </Tabs>
            <TabPanel className="tabpanelControl" value="1">
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <div className="searchBar">
                      <input
                        type="text"
                        autoComplete="off"
                        placeholder="Search"
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                      />
                    </div>
                    <div style={{ minWidth: 250,    marginBottom: "24px"}}>
                      <Autocomplete
                        options={locations}
                        getOptionLabel={(option) =>
                          option.organizationName || ""
                        }
                        value={selectedLocation}
                        onChange={(_, newValue) => {
                          setSelectedLocation(newValue);
                        }}
                        inputValue={locationSearch}
                        onInputChange={(_, newInputValue) => {
                          setLocationSearch(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                          style={{ paddingTop: "1px" }}
                            {...params}
                            size="small"
                            placeholder="Search location"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#fff",
                                "& .MuiOutlinedInput-input": {
                                  color: "#6e6e71",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "rgba(224, 224, 224, 1)",
                                  borderWidth: "1px",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "rgba(224, 224, 224, 1)",
                                },
                              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "rgba(224, 224, 224, 1)",
                                },
                              "& .MuiInputBase-root:hover": {
                                boxShadow: "none",
                                backgroundColor: "#fff",
                              },
                            }}
                          />
                        )}
                        clearOnEscape
                        isOptionEqualToValue={(option, value) =>
                          option._id === value._id
                        }
                      />
                    </div>
                  </div>
                  <button
                    className="btn blackoutlineBtn"
                    onClick={downloadCSVFile}
                  >
                    Download CSV
                  </button>
                </div>

                <AdminLogsDetails
                  type="audit"
                  search={search}
                  organizationId={selectedLocation?._id || ""}
                />
              </div>
            </TabPanel>
            <TabPanel className="tabpanelControl" value="2">
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <div className="searchBar">
                      <input
                        type="text"
                        autoComplete="off"
                        placeholder="Search"
                        value={search}
                        onChange={(event) => setSearch(event.target.value)}
                      />
                    </div>
                    <div style={{ minWidth: 250, marginBottom: "24px" }}>
                      <Autocomplete
                        options={locations}
                        getOptionLabel={(option) =>
                          option.organizationName || ""
                        }
                        value={selectedLocation}
                        onChange={(_, newValue) => {
                          setSelectedLocation(newValue);
                        }}
                        inputValue={locationSearch}
                        onInputChange={(_, newInputValue) => {
                          setLocationSearch(newInputValue);
                        }}
                        renderInput={(params) => (
                          <TextField
                            style={{ paddingTop: "1px" }}
                            {...params}
                            size="small"
                            placeholder="Search location"
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "#fff",
                                "& .MuiOutlinedInput-input": {
                                  color: "#6e6e71",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  borderColor: "rgba(224, 224, 224, 1)",
                                  borderWidth: "1px",
                                },
                              },
                              "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "rgba(224, 224, 224, 1)",
                                },
                              "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "rgba(224, 224, 224, 1)",
                                },
                              "& .MuiInputBase-root:hover": {
                                boxShadow: "none",
                                backgroundColor: "#fff",
                              },
                            }}
                          />
                        )}
                        clearOnEscape
                        isOptionEqualToValue={(option, value) =>
                          option._id === value._id
                        }
                      />
                    </div>
                  </div>
                  <button
                    className="btn blackoutlineBtn"
                    onClick={downloadCSVFile}
                  >
                    Download CSV
                  </button>
                </div>
                <AdminLogsDetails
                  type="login"
                  search={search}
                  organizationId={selectedLocation?._id || ""}
                />
              </div>
            </TabPanel>
            <TabPanel value="3">
              <div className="topsearchs">
                <AdminFormSortLogs search={search} setSearch={setSearch} />
              </div>
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>
  );
};
